import { cn } from "@/lib/utils";
import type { ActionBreakdownItem } from "../types";

export interface BreakdownItemProps {
  item: ActionBreakdownItem;
  className?: string;
}

export function BreakdownItem({ item, className }: BreakdownItemProps) {
  return (
    <div
      className={cn(
        "flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2",
        "p-3 sm:px-4 bg-bb-black mb-1",
        className
      )}
    >
      <span className="text-bb-bone-white text-sm font-medium">
        {item.index}. {item.name}
      </span>

      <div className="flex items-center gap-3 w-full sm:w-auto justify-between sm:justify-end pt-2 sm:pt-0 border-t sm:border-t-0 border-bb-gray-mid mt-1 sm:mt-0">
        <div className="flex items-center gap-1.5 flex-wrap">
          {item.hasReroll && item.probWithReroll !== null ? (
            <>
              <span className="text-bb-bone-white/50 text-sm">
                {(item.baseProb * 100).toFixed(1)}%
              </span>
              <span className="text-bb-bone-white/50 text-sm">→</span>
              <span className="font-condensed font-bold text-bb-gold text-sm">
                {(item.probWithReroll * 100).toFixed(1)}%
              </span>
              {item.rerollNote && (
                <span className="text-bb-gold/80 text-xs">
                  [{item.rerollNote}]
                </span>
              )}
            </>
          ) : (
            <span className="font-condensed font-bold text-bb-gold text-sm">
              {(item.baseProb * 100).toFixed(1)}%
            </span>
          )}
        </div>

        <span className="text-green-400 font-condensed font-semibold min-w-[55px] text-right">
          ▸ {(item.cumulativeProb * 100).toFixed(1)}%
        </span>
      </div>
    </div>
  );
}
